import React from "react";
import { StyledLoadMoreButton } from "./index.styled";

interface LoadMoreButtonProps {
  onClick: () => void;
  loading: boolean;
  hasMore: boolean;
  currentCount: number;
  totalCount?: number;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  loading,
  hasMore,
}) => {
  if (!hasMore) {
    return null;
  }

  return (
    <StyledLoadMoreButton onClick={onClick} disabled={loading}>
      {loading ? (
        <div className="loading-content">
          <span>טוען</span>
          <div className="spinner" />
        </div>
      ) : (
        <div className="button-content">
          <span>טען עוד</span>
        </div>
      )}
    </StyledLoadMoreButton>
  );
};

export default LoadMoreButton;
